/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSourceTagRequest } from './CreateSourceTagRequest';
import {
    CreateSourceTagRequestFromJSON,
    CreateSourceTagRequestFromJSONTyped,
    CreateSourceTagRequestToJSON,
    CreateSourceTagRequestToJSONTyped,
} from './CreateSourceTagRequest';

/**
 * 
 * @export
 * @interface CreateSourceTag201Response
 */
export interface CreateSourceTag201Response {
    /**
     * 
     */
    data?: CreateSourceTagRequest;
}

/**
 * Check if a given object implements the CreateSourceTag201Response interface.
 */
export function instanceOfCreateSourceTag201Response(value: object): value is CreateSourceTag201Response {
    return true;
}

export function CreateSourceTag201ResponseFromJSON(json: any): CreateSourceTag201Response {
    return CreateSourceTag201ResponseFromJSONTyped(json, false);
}

export function CreateSourceTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceTag201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateSourceTagRequestFromJSON(json['data']),
    };
}

export function CreateSourceTag201ResponseToJSON(json: any): CreateSourceTag201Response {
    return CreateSourceTag201ResponseToJSONTyped(json, false);
}

export function CreateSourceTag201ResponseToJSONTyped(value?: CreateSourceTag201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateSourceTagRequestToJSON(value['data']),
    };
}

